<template>
    <div class="relative" v-tooltip="tooltip">
        <nio-icon
            class="text-lg text-gray-500"
            name="bold/messages-bubble-text_1"
        />
        <div
            class="absolute right-0 bottom-0 h-2 w-2 -mr-px -mb-px text-white rounded-full shadow-solid | group-hover:text-gray-100"
            :class="badgeColor"
            v-if="badgeColor"
        />
    </div>
</template>

<script>
    export default {
        props: {
            contact: {
                type: Object,
                required: true,
            },
            sent: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            phones() {
                return this.contact.phones || [];
            },

            badgeColor() {
                if (!this.contact.subscribed) {
                    return 'bg-yellow-500';
                }

                if (this.sent) {
                    return 'bg-green-500';
                }

                if (!this.hasPhone || !this.hasValidPhone) {
                    return 'bg-red-500';
                }

                return 'bg-gray-400';
            },

            tooltip() {
                if (!this.contact.subscribed) {
                    return this.$t('appointments.appointmentsList.contactUnsubscribed');
                }

                if (this.sent) {
                    return `${this.$t('global.general.sms')} ${this.$t('global.general.sent').toLowerCase()}`;
                }

                if (!this.hasPhone) {
                    return this.$t('contacts.phones.none');
                }

                if (!this.hasValidPhone) {
                    return this.$t('contacts.phones.allInvalid');
                }

                return `${this.$t('global.general.sms')} ${this.$t('global.general.notSent').toLowerCase()}`;
            },

            hasPhone() {
                return this.phones.some(p => !empty(p.number));
            },

            hasValidPhone() {
                return this.phones.some(phone => {
                    return this.phoneIsValid(phone);
                });
            },
        },
    };
</script>
